<div [style.display]="'none'" class="file-util-holder" #fileUtilHolder></div>